import WebService from "../WebService";

const Upsell = {
  gets(params) {
    return WebService.get("/trigger?" + params);
  },
  get(upsell_id, params) {
    return WebService.get("/trigger/" + upsell_id + "?" + params);
  },
  create(data) {
    return WebService.post("/trigger", data);
  },
  update(data) {
    console.log(data)
    return WebService.post("/trigger/" + data.trigger_id, data);
  },
  delete(trigger_id) {
    return WebService.post("/trigger/" + trigger_id + "/delete");
  },
};
export default Upsell;
